import React, {useState} from 'react'
import VisDiv from '../frontend_components/VisDiv'
import axios from 'axios'
import { useStateContext } from '../../context/StateContext'
import { useAuthContext } from '../../hooks/useAuthContext'
import { FaCheck, FaTimes } from 'react-icons/fa'

/**
 * UpdatePassword is a component that allows users to update their password
 *  
 * The component requires the user to enter a new password, confirm the new password, and meet certain password validation criteria
 * 
 * The component also allows users to bypass the new password step and go directly to the login page
 * 
 * The component displays errors if the user does not meet the password validation criteria or if the update password request fails
 * 
 * The component uses the useStateContext hook to get the user state and the apiUrl
 * 
 * The component uses the useAuthContext hook to get the user and dispatch functions
 * #login
 */
const UpdatePassword = () => {
    const [newPassword, setNewPassword] = useState("")    
    const [confirmPassword, setConfirmPassword] = useState("") 
    const { sUser, setSUser, setBypassNewPassword, bypassNewPassword, apiUrl } = useStateContext()
    const {dispatch, user} = useAuthContext()
    const [updateError, setUpdateError] = useState(undefined)
    
    // Password validation state
    const [passwordValidation, setPasswordValidation] = useState({
        minLength: false,
        minLowercase: false,
        minUppercase: false,
        minNumbers: false,
        minSymbols: false
    })

    const handlePasswordChange = (e) => {
        const password = e.target.value;
        setNewPassword(password);
        
        // Update validation states
        setPasswordValidation({
            minLength: password.length >= 8,
            minLowercase: /[a-z]/.test(password),
            minUppercase: /[A-Z]/.test(password),
            minNumbers: /[0-9]/.test(password),
            minSymbols: /[!@#$%^&*(),.?":{}|<>]/.test(password)
        });
    };

    const ValidationItem = ({ isValid, text }) => (
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            color: isValid ? '#4CAF50' : '#f44336',
            marginBottom: '4px',
            fontSize: '14px'
        }}>
            {isValid ? <FaCheck /> : <FaTimes />}
            {text}
        </div>
    );

    const updatePassord = async (newPassword) => {
        const request = async (req, res) => {
          try {
            const response = await axios.post(
                `${apiUrl}/users/update-password`, 
                { newPassword, sUser },
                {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`
                }
                }
            );

            if (response.status === 200) {
              const data = response.data
                const updatedSUserDoc = {...sUser, passwordExists: true}
                const doc = {...user, passwordExists: true}
                localStorage.setItem('user', JSON.stringify(doc))
                setSUser(updatedSUserDoc)
                dispatch({type: 'LOGIN', payload: doc})
            } 
          } catch (error) {
            console.log("CATCH ERROR", error)
            setUpdateError(error?.response?.data?.error);
          }
        }

        request()
    }

    return (
        <div style={{width:"100%", height:"100vh"}}>
            <div style={{position:"absolute", top:0, left:0, width:"100%", height:"100%", backgroundColor:"rgba(0,0,0,0.7)"}}></div>
            <video
                src={"/assets/share.mp4"}
                type="video/mp4"
                loop="loop"
                controls={false}
                muted={true}
                autoPlay="autoPlay"
                playsInline
                style={{width:"100%", height: "100%", objectFit:"cover"}}
            />
            <div style={{position:"absolute", width:"100%", height: "100%", top:0, display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", color:"white"}}>
                <img src="/assets/logowhite.png" alt="logoWhite" style={{width:"70px", height:"50", marginBottom:"15px"}} />
                <VisDiv rules={[true]}>
                    <label style={{color: "white"}}>{"INSERISCI NUOVA PASSWORD"}</label>
                    <input 
                        style={{background:"rgba(0,0,0,0)", color: "white"}}  
                        type="password" 
                        onChange={handlePasswordChange} 
                        value={newPassword} 
                    />
                    <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <ValidationItem isValid={passwordValidation.minLength} text="Almeno 8 caratteri" />
                        <ValidationItem isValid={passwordValidation.minLowercase} text="Almeno 1 lettera minuscola" />
                        <ValidationItem isValid={passwordValidation.minUppercase} text="Almeno 1 lettera maiuscola" />
                        <ValidationItem isValid={passwordValidation.minNumbers} text="Almeno 1 numero" />
                        <ValidationItem isValid={passwordValidation.minSymbols} text="Almeno 1 carattere speciale" />
                    </div>
                </VisDiv>
                <VisDiv rules={[newPassword]}>
                    <label style={{color: "white"}}>{"CONFERMA NUOVA PASSWORD"}</label>
                    <input 
                        style={{background:"rgba(0,0,0,0)", color: "white"}}  
                        type="password" 
                        onChange={(e) => setConfirmPassword(e.target.value)} 
                        value={confirmPassword} 
                    />
                </VisDiv>
                <VisDiv rules={[
                    newPassword && 
                    newPassword === confirmPassword && 
                    Object.values(passwordValidation).every?.(Boolean)
                ]}>
                    <div style={{cursor:"pointer", marginBottom:"20px"}} onClick={() => updatePassord(newPassword)} className="login-button">
                        AGGIORNA
                    </div>
                </VisDiv>
                <div onClick={() => setBypassNewPassword(true)} className="login-button">
                    SALTA
                </div>
                <VisDiv rules={[updateError]}>
                    {<div style={{background:"rgba(0,0,0,0)"}} className="error">{updateError}</div>}
                </VisDiv>
            </div>
        </div>
    )
}

export default UpdatePassword
